import type {IAsset} from '@netx/core-asset-next/schema';
import {assetIsPresent} from '@netx/core-asset-next/enablers/assetIsPresent';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';

export const canSelectCustomThumbnail = (asset?: IAsset) => {
	if (asset == null || !assetIsPresent(asset)) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.SET_CUSTOM_THUMBNAIL,
	});
};
